import { render } from "./ModalNuovoLeadCliente.vue?vue&type=template&id=37605653&scoped=true"
import script from "./ModalNuovoLeadCliente.vue?vue&type=script&lang=js"
export * from "./ModalNuovoLeadCliente.vue?vue&type=script&lang=js"

import "./ModalNuovoLeadCliente.vue?vue&type=style&index=0&id=37605653&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_jecko_1768814729495645082/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37605653"]])

export default __exports__